import React, { useState } from 'react'
import { toast } from 'react-toastify'

import { Button, Dialog } from '@clientbase/clientbase-library'
import { Box } from '@mui/material'
import { DataService } from 'api/DataService'
import moment from 'moment'
import { useAccountsPayableContext } from 'templates/AccountsPayable/context'

import { formatMoney } from 'utils'
import { toastProps } from 'utils/types/toast-props'

import Item from '../../Item'

interface ExpensesDetailsPaymentProps {
  payment_source_name: string
  amountPaid: string | number
  datePaid: string
  uuid?: string
}
const ExpensesDetailsPayment = ({
  payment_source_name,
  amountPaid,
  datePaid,
  uuid
}: ExpensesDetailsPaymentProps) => {
  const [isOpenDialogUnpay, setIsOpenDialogUnpay] = useState<boolean>(false)
  const { setReloadTable, reloadTable, setExpenseDetailModal } =
    useAccountsPayableContext()

  // A ação fica aqui, junto dos dados que ela desfaz (mesmo lugar que a cobrança usa no
  // PaymentDetails do ModalChargeDetail), e não no rodapé do modal: no rodapé ela
  // competia com Editar/Excluir sem dizer o que exatamente seria desfeito.
  const handleUnpay = async () => {
    setIsOpenDialogUnpay(false)
    const id = toast.loading('Desmarcando o pagamento...')

    const response = await DataService({
      url: `/v1/accounts_payables/${uuid}/pay`,
      type: 'DELETE'
    })

    if (!response.error) {
      setExpenseDetailModal({ isOpen: false, uuid: '' })
      setReloadTable(!reloadTable)
    }

    toast.update(id, {
      render: response.error
        ? response.detail_error ||
          response.message ||
          'Ocorreu um erro ao desmarcar o pagamento'
        : 'Pagamento desmarcado com sucesso',
      type: response.error ? 'error' : 'success',
      ...toastProps
    })
  }

  return (
    <>
      {payment_source_name && (
        <Item textKey={'Pago com'} value={payment_source_name} />
      )}

      <Item
        textKey="Data de pagamento"
        value={moment(datePaid).format('DD/MM/YYYY')}
      />
      <Item textKey="Valor pago" value={formatMoney(amountPaid)} />

      {uuid && (
        <Box display="flex" justifyContent="flex-end" mt={1}>
          <Button
            variantButton="ghost"
            startIcon="delete"
            onClick={() => setIsOpenDialogUnpay(true)}
          >
            Desmarcar pagamento
          </Button>
        </Box>
      )}

      <Dialog
        icon="close"
        title=""
        description="Confirma desmarcar o pagamento dessa despesa?"
        isOpenDialog={isOpenDialogUnpay}
        setIsOpenDialog={setIsOpenDialogUnpay}
      >
        <Button
          variantButton="neutral"
          onClick={() => setIsOpenDialogUnpay(false)}
          fullWidth
        >
          Voltar
        </Button>
        <Button autoFocus onClick={handleUnpay} fullWidth>
          Desmarcar
        </Button>
      </Dialog>
    </>
  )
}

export default ExpensesDetailsPayment
